import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import EditNoteModal from './EditNotes';
import { GetQuery } from './Shared';

interface JobSearchManualProps {
    showModal: boolean;
    hideModal(): void;
}

interface JobSearchResults {
    systemCompanyId: number;
    scheduleId: number;
    scheduleIdFormatted: string;    //making this a string as I'll add an M at the start to make it unique from the job
    jobId: number;                  //some manual jobs are linked to an actual job
    siteAddress: string;
    customer: string;
    contact: string;
    description: string;
    scheduleDateFormatted: string;
    allocated: string;
    notes: string;
    status: string;
}

const JobSearchManualData = (props: JobSearchManualProps) => {
    const [siteAddress, setSiteAddress] = React.useState("");
    const [results, setResults] = React.useState<JobSearchResults[]>([]);
    const [showSearchResults, setShowSearchResults] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [showEditNotesModal, setShowEditNotesModal] = React.useState(false);
    const [systemCompanyId, setSystemCompanyId] = React.useState(3);
    const [scheduleId, setScheduleId] = React.useState(-1);
    const [jobIndex, setJobIndex] = React.useState(-1);

    const hideModal = () => {
        setSiteAddress("");
        setResults([]);
        setShowSearchResults(false);
        setLoading(false);
        props.hideModal();
    }

    const search = (e: any) => {
        e.preventDefault();
        if (siteAddress.trim() != "") {
            setLoading(true);
            setShowSearchResults(true);
            searchManualJobs();
        } else {
            toast.error("Please enter part of a site address to search!");
        }
    }

    const searchManualJobs = async () => {
        const apiUrl = "SearchManualJobs?SiteAddress=" + siteAddress;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                setResults(result.data.results);
                setLoading(false);
            }
        }
    }

    //EDIT NOTES
    const openEditNotesModal = (e: any, itemIndex: number) => {
        e.preventDefault();

        var result = results[itemIndex];

        setSystemCompanyId(result.systemCompanyId);
        setScheduleId(result.scheduleId);
        setJobIndex(itemIndex);
        setShowEditNotesModal(true);

    }

    const hideEditNotesModal = () => {
        setScheduleId(-1);
        setJobIndex(-1);
        setShowEditNotesModal(false);
    }

    const saveEditNotesModal = (scheduleNotes: string, _timestamp: Uint8Array) => {
        var editResults = [...results];
        var result = editResults[jobIndex];
        result.notes = scheduleNotes;

        setScheduleId(-1);
        setJobIndex(-1);
        setResults(editResults);
        setShowEditNotesModal(false);
    }
    //END EDIT NOTES

    var editNotes = <EditNoteModal systemCompanyId={systemCompanyId} scheduleId={scheduleId} editDriverNotes={false} showDriverScheduleNotes={false} showEditNotesModal={showEditNotesModal} save={saveEditNotesModal} hideModal={hideEditNotesModal} />

    return (
        <div>
            <div>
                {editNotes}
            </div>
        
            <div className="static-modal">
                <Modal size='xl' show={props.showModal} onHide={hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Search Manual Jobs</Modal.Title>
                        <button type="button" className="close" onClick={hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="input-group--inline" htmlFor="siteAddressSearch">
                            <span className="label label--setsizesm">Site Address</span>
                            <input className="input schedulenew__addSearch--width-lg" type="text" id="siteAddressSearch" name="siteAddressSearch" value={siteAddress} onChange={(e) => setSiteAddress(e.target.value)}></input>
                        </label>

                        <button className="defaultbutton defaultbutton__small allocate__searchMargin" type='button' onClick={(e) => search(e)}>Search</button>

                        <div className={loading && showSearchResults ? "" : "hidden"}>Searching...</div>
                        <div className={!loading && showSearchResults ? "" : "hidden"}>
                            <div className="overflowAuto schedulenew__result--height">
                                <table className='table tableColours'>
                                    <thead>
                                        <tr>
                                            <th className="hidden">Sch Id</th>
                                            <th>Id</th>
                                            <th>Job Id</th>
                                            <th>Site Address</th>
                                            <th>Customer</th>
                                            <th>Contact</th>
                                            <th>Description</th>
                                            <th>Date</th>
                                            <th>Allocated</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {results.map((result, index) =>
                                            <tr key={index}>
                                                <td className="hidden">{result.scheduleId}</td>
                                                <td>{result.scheduleIdFormatted}</td>
                                                <td>
                                                    <Link className={result.jobId === 0 ? "hidden" : ""} to={'/job/' + result.jobId + '/details'} target="_blank" >
                                                        {result.jobId}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <div className="tooltipitem  tooltipitem__right">{result.siteAddress ? result.siteAddress.substring(0, 40) + "... " : ""}
                                                        <span className="tooltipitemtext  tooltipitemtext__right">{result.siteAddress}</span>
                                                    </div>
                                                </td>
                                                <td>{result.customer}</td>
                                                <td>{result.contact}</td>
                                                <td>{result.description}</td>
                                                <td>{result.scheduleDateFormatted}</td>
                                                <td>{result.allocated}</td>
                                                <td>{result.status}</td>
                                                <td>
                                                    <a className={result.notes == "" ? "hidden" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => openEditNotesModal(e, index)}>
                                                        <div className="tooltipitem tooltipitem__left">{result.notes ? result.notes.length < 20 ? result.notes : result.notes.substring(0, 20) + "... " : ""}
                                                            <span className="tooltipitemtext tooltipitemtext__left">{result.notes}</span>
                                                        </div>
                                                    </a>
                                                    <a className={result.notes != "" ? "hidden" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => openEditNotesModal(e, index)}>
                                                        <span className="fas fa-pencil-alt edit--icon alignIconCenter"></span>
                                                    </a>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        
                            <span className={showSearchResults && results.length == 0 ? "" : "hidden"}>There were no matching jobs found. Try modifying your search criteria.</span>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="popup-button--yes" onClick={hideModal}>Close</button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    ); 
}

export default JobSearchManualData;